// extracted by mini-css-extract-plugin
export default {"btn":"ExitBtn_btn__j2P-5"};